// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button__Button--3JBBJ","error":"Button__error--Qwew7","success":"Button__success--2D3Hf","primary":"Button__primary--1bMru"};